const results = [
  {
    metric: '3 minutes',
    label: 'Average time from start to launch-ready ad',
    icon: 'ri-time-line',
    color: 'text-orange-500',
    bg: 'bg-orange-50',
    description: 'Most users generate their first ad in under 3 minutes — including setup. No learning curve, no tutorials needed.',
  },
  {
    metric: '47%',
    label: 'Average CTR improvement over manually written ads',
    icon: 'ri-line-chart-line',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    description: 'AdForge users report significantly higher click-through rates because the AI applies proven conversion frameworks to every ad.',
  },
  {
    metric: '6+ hours',
    label: 'Saved per week by agency users',
    icon: 'ri-calendar-check-line',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    description: 'Agencies managing multiple clients save 6 or more hours every week by replacing manual ad writing with AI generation.',
  },
  {
    metric: '$400+',
    label: 'Average monthly savings vs. hiring a copywriter',
    icon: 'ri-money-dollar-circle-line',
    color: 'text-rose-500',
    bg: 'bg-rose-50',
    description: 'The average freelance copywriter charges $100–$200 per ad. AdForge replaces that cost entirely — starting free.',
  },
];

const whatYouGet = [
  { icon: 'ri-file-copy-line', text: 'Complete ad copy — hook, headline, body, and CTA' },
  { icon: 'ri-image-line', text: 'AI-generated creative image in platform dimensions' },
  { icon: 'ri-layout-4-line', text: 'Multiple variations ready for A/B testing' },
  { icon: 'ri-clipboard-line', text: 'One-click copy for your ad manager' },
  { icon: 'ri-download-2-line', text: 'Downloadable image at correct platform size' },
  { icon: 'ri-save-line', text: 'Auto-saved to your ad history library' },
];

export default function HIWResults() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* What you get */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Output</span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            What You Get From Each AI Ad Generation
          </h2>
          <p className="text-stone-500 text-base leading-relaxed">
            One click. One complete, launch-ready ad package. Here&apos;s everything that lands in
            your dashboard after a single generation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
          {whatYouGet.map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-3 bg-stone-50 rounded-xl px-5 py-4 border border-stone-100"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-orange-50 flex-shrink-0">
                <i className={`${item.icon} text-orange-500 text-lg`} />
              </div>
              <span className="text-sm font-semibold text-stone-700">{item.text}</span>
            </div>
          ))}
        </div>

        {/* Results metrics */}
        <div className="text-center max-w-xl mx-auto mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Real Results</span>
          <h3 className="text-2xl lg:text-3xl font-black text-stone-900 mb-3 leading-tight">
            What Happens After You Create Ads with AI
          </h3>
          <p className="text-stone-500 text-sm leading-relaxed">
            Based on aggregated data and user reports from AdForge customers across industries.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {results.map((r) => (
            <article key={r.metric} className={`rounded-2xl border border-stone-100 p-6 ${r.bg}`}>
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-white mb-4`}>
                <i className={`${r.icon} text-xl ${r.color}`} />
              </div>
              <div className={`text-3xl font-black ${r.color} mb-1`}>{r.metric}</div>
              <div className="text-xs font-bold text-stone-700 mb-3 leading-snug">{r.label}</div>
              <p className="text-xs text-stone-500 leading-relaxed">{r.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
